import React from "react"
import { Link, useLocation } from "react-router-dom"

import {
  callToLearnMoreButtonClicked,
  contactSalesTeamButtonClicked,
} from "utils/segment"

import Container from "./Container"
import Row from "./Row"
import Col from "./Col"
import { returnNullFooterPathNames } from "constants/returnNullFooterPathNames"

import Logo from "../assets/logo.svg"
import Facebook from "../assets/facebook-icon.png"
import Instagram from "../assets/ig-icon.png"
import LinkedIn from "../assets/linkedin-icon.svg"
import Twitter from "../assets/twitter.svg"

const Footer = () => {
  const location = useLocation()

  if (returnNullFooterPathNames.includes(location.pathname)) {
    return null
  }

  return (
    <div className="footer">
      <Container>
        {location.pathname !== "/pals/signup" && (
          <Row>
            <Col md={4} className="flex direction-column space-between">
              <div className="footer__main flex align-center">
                <Link to="/">
                  <img src={Logo} alt="Papa" className="brand mr-20" />
                </Link>

                <div>
                  <p className="mb-0">Miami, FL</p>
                  <p className="mb-0">
                    <a
                      href="tel:+1-800-348-7951"
                      onClick={callToLearnMoreButtonClicked}
                    >
                      1-800-348-7951
                    </a>
                  </p>
                </div>
              </div>

              <div className="footer__social mt-30 hidden-mobile">
                <h4 className="mb-15">Join our Papa communities</h4>

                <a
                  href="https://www.facebook.com/joinpapa/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mr-30"
                >
                  <img src={Facebook} alt="Papa Facebook" />
                </a>

                <a
                  href="https://www.instagram.com/join_papa/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mr-30"
                >
                  <img src={Instagram} alt="Papa Instagram" />
                </a>

                <a
                  href="https://www.linkedin.com/company/10879786"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mr-30"
                >
                  <img src={LinkedIn} alt="Papa LinkedIn" />
                </a>

                <a
                  href="https://twitter.com/join_papa"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Twitter} alt="Papa Twitter" />
                </a>
              </div>
            </Col>

            <Col md={3}>
              <ul>
                <li>Quick Links</li>
                <li>
                  <Link
                    to="/contact-sales"
                    onClick={contactSalesTeamButtonClicked}
                  >
                    Contact Enterprise Sales
                  </Link>
                </li>
                <li>
                  <Link to="/blog">Blog</Link>
                </li>
                <li>
                  <Link to="/locations">Locations</Link>
                </li>
                <li>
                  <Link to="/pals/signup">Become a Papa Pal</Link>
                </li>
                <li>
                  <Link to="/pal-local-jobs">Local Jobs for Pals</Link>
                </li>
                <li>
                  <Link to="/video-gallery">Video Gallery</Link>
                </li>
                <li>
                  <Link to="/hipaa-privacy-rule">HIPAA Privacy Rule</Link>
                </li>
              </ul>
            </Col>

            <Col md={2}>
              <ul>
                <li>About Us</li>
                <li>
                  <Link to="/about-papa-team">About</Link>
                </li>
                <li>
                  <Link to="/careers">Careers</Link>
                </li>
                <li>
                  <Link to="/media">Media</Link>
                </li>
              </ul>
            </Col>
          </Row>
        )}
        <hr />

        <div className="legal flex">
          <div className="mr-30">Papa Inc © {new Date().getFullYear()}</div>
          <div>
            {location.pathname === "/pals/signup" && (
              <>
                <a
                  href="https://joinpapa.notion.site/Welcome-to-the-Pal-Content-Hub-08b4397cecb74fbc8323b51bade4d53f"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Pal FAQ
                </a>{" "}
                |{" "}
              </>
            )}
            <Link to="/terms-of-use">Terms of Service</Link> |{" "}
            <Link to="/privacy-policy">Privacy Policy</Link> |{" "}
            <Link to="/end-user-agreement">End User Agreement</Link> |{" "}
            <a
              href="https://joinpapa.ethicspoint.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ethics and Conduct Reporting
            </a>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Footer
